import { GlobalAxios } from "./../axios/axios-config";
import {
  INewIntegrationRuleNotification,
  IIntegrationRuleNotification,
} from "../models/integration-rule-notification";

const INTEGRATION_RULE_NOTIFICATION_ROUTE =
  process.env.REACT_APP_MAIN + "/api/v1/4uBusIntegrationRuleNotification/";

export const createIntegrationRuleNotification = (
  item: INewIntegrationRuleNotification,
) => {
  return GlobalAxios.post(INTEGRATION_RULE_NOTIFICATION_ROUTE, item);
};

export const getIntegrationRuleNotificationById = (id: string) => {
  return GlobalAxios.get<IIntegrationRuleNotification>(
    INTEGRATION_RULE_NOTIFICATION_ROUTE + id,
  );
};

export const updateIntegrationRuleNotificationById = ({
  item,
  id,
}: {
  item: INewIntegrationRuleNotification;
  id: string;
}) => {
  return GlobalAxios.put(INTEGRATION_RULE_NOTIFICATION_ROUTE + id, item);
};
